import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=80a902e8&lang=pug"
import script from "./ImageUpload.vue?vue&type=script&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&lang=ts"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=80a902e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports